const axios = require("axios");

export const Axios = axios.create({
  // baseURL: process.env.REACT_APP_API_SERVER_URL,
  // baseURL: "https://alloapi.tmsosial.asia",
  baseURL: "https://hanoman.allobank.com",
  headers: {},
  timeout: 30000,
});
